import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=9947a3e6&scoped=true"
import script from "./Action.js?vue&type=script&lang=js&external"
export * from "./Action.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9947a3e6",
  null
  
)

export default component.exports